import { EPromotionStatus } from '@/services/connecteur'

export class DataRetourActionComponent {
  newStatus: EPromotionStatus;
  reason: number;

  constructor(newStatus: EPromotionStatus, reason = 0) {
    this.newStatus = newStatus
    this.reason = reason
  }
}
